// extracted by mini-css-extract-plugin
module.exports = {"quotaInput":"AnswerQuotaInput_quotaInput__1AOnr","disabled":"AnswerQuotaInput_disabled__Rurxj"};